module.exports = __webpack_public_path__ + "img/00003.ff39e613.webp";